import GirlHammock from 'images/landing/GirlHammock.jpg';
import TravelerGirlGreece from 'images/landing/TravelerGirlGreece.jpg';
import FriendsJumpingPool from 'images/landing/FriendsJumpingPool.jpg';
import CashBackCard from 'images/rewardsOverview/cashBackSquare.png';
import CashForACauseCard from 'images/rewardsOverview/cashForACauseSquare.png';
import CashForACauseMondrianCard from 'images/rewardsOverview/cashForACauseMondrianSquare.jpg';
import CashForwardCard from 'images/rewardsOverview/cashForwardSquare.png';
import CashForwardMondrianCard from 'images/rewardsOverview/cashForwardMondiranSquare.jpg';
import InStayCard from 'images/rewardsOverview/instaySquare.png';
import TilePhoneImg from 'images/rewardsOverview/tilePhone.png';
import FooterPhoneImg from 'images/rewardsOverview/phone.png';
import InstayBanner from 'images/rewardsOverview/instayBanner.png';
import CashBackBanner from 'images/rewardsOverview/cashBackBanner.png';
import CashForACauseBanner from 'images/rewardsOverview/cashForACauseBanner.png';
import CashForACauseMondrianBanner from 'images/rewardsOverview/cashForACauseMondrianBanner.jpg';
import CashForwardBanner from 'images/rewardsOverview/cashForwardBanner.png';
import CashForwardMondrianBanner from 'images/rewardsOverview/cashForwardMondrianBanner.jpg';
import {siteUrls} from './websiteURLs';
import I18n from '../translations/i18n';

import CashBackYotelCard from 'images/rewardsOverview/yotel_rewards/yotelCashback.jpg';
import CashBackYotelBanner from 'images/rewardsOverview/yotel_rewards/yotelCashbackBanner.jpg';
import CashForACauseYotelCard from 'images/rewardsOverview/yotel_rewards/yotelCashForACause.jpg';
import CashForACauseYotelBanner from 'images/rewardsOverview/yotel_rewards/yotelCashForACauseBanner.jpg';
import CashForwardYotelCard from 'images/rewardsOverview/yotel_rewards/yotelCashForward.jpg';
import CashForwardYotelBanner from 'images/rewardsOverview/yotel_rewards/yotelCashForwardBanner.jpg';
import InstayYotelCard from 'images/rewardsOverview/yotel_rewards/yotelInStayCash.jpg';
import InstayYotelBanner from 'images/rewardsOverview/yotel_rewards/yotelInStayCashBanner.jpg';


export const numOfCountries = '78';
export const numOfHotels = '800';

//How it Works Section of Landing
export const howItWorksSectionData = {
  title: I18n.t('views.static_pages.landing.section_2.header_1.text_1'),
  subtitle: I18n.t('views.static_pages.landing.section_2.header_1.sub_text_1'),
  directions: [
    {
      bulletPoint: I18n.t('views.static_pages.landing.section_2.header_2.text_1'),
      description: I18n.t('views.static_pages.landing.section_2.header_2.sub_text_1')
    },
    {
      bulletPoint: I18n.t('views.static_pages.landing.section_2.header_3.text_1'),
      description: I18n.t('views.static_pages.landing.section_2.header_3.sub_text_1')
    },
    {
      bulletPoint: I18n.t('views.static_pages.landing.section_2.header_4.text_1'),
      description: I18n.t('views.static_pages.landing.section_2.header_4.sub_text_1')
    }
  ]
};

//How it Works Section of Hotel Landing
export const hotelHowItWorksSectionData = {
  title: I18n.t('views.static_pages.hotel_landing.section_2.header_1.text_1'),
  subtitle: '',
  directions: [
    {
      bulletPoint: I18n.t('views.static_pages.landing.section_2.header_2.text_1'),
      description: I18n.t('views.static_pages.landing.section_2.header_2.sub_text_1')
    },
    {
      bulletPoint: I18n.t('views.static_pages.landing.section_2.header_3.text_1'),
      description: I18n.t('views.static_pages.hotel_landing.section_2.header_3.sub_text_1', {hotel: '*HOTEL_NAME*'})
    },
    {
      bulletPoint: I18n.t('views.static_pages.landing.section_2.header_4.text_1'),
      description: I18n.t('views.static_pages.hotel_landing.section_2.header_4.sub_text_1')
    }
  ]
};

// Steps Section of Landing
export const stepsSectionData = [
  {
    id: 0,
    title: I18n.t('views.static_pages.landing.section_3.header_1.text_1'),
    image: FriendsJumpingPool,
    imageAlt: 'Friends Jumping into Pool',
    descriptionType: 'paragraph',
    descriptionContent: I18n.t('views.static_pages.landing.section_3.header_1.sub_text_1'),
    button: true,
    buttonName: I18n.t('views.navigation.explore_hotels'),
    buttonRoute: siteUrls.navigation.exploreHotels.href,
    alignment: 'left'
  },
  {
    id: 1,
    title: I18n.t('views.static_pages.landing.section_4.header_1.text_1'),
    image: TravelerGirlGreece,
    imageAlt: 'Traveler Girl in Greece',
    descriptionType: 'paragraph',
    descriptionContent: I18n.t('views.static_pages.landing.section_4.header_1.sub_text_1'),
    button: false,
    alignment: 'right'
  },
  {
    id: 2,
    title: I18n.t('views.static_pages.landing.section_5.header_1.text_1'),
    image: GirlHammock,
    imageAlt: 'Girl in Hammock',
    descriptionType: 'list',
    descriptionContent: [
      {
        title: I18n.t('views.static_pages.landing.section_5.header_2.text_1'),
        description: I18n.t('views.static_pages.landing.section_5.header_2.sub_text_1')
      },
      {
        title: I18n.t('views.static_pages.landing.section_5.header_3.text_1'),
        description: I18n.t('views.static_pages.landing.section_5.header_3.sub_text_1')
      },
      {
        title: I18n.t('views.static_pages.landing.section_5.header_4.text_1'),
        description: I18n.t('views.static_pages.landing.section_5.header_4.sub_text_1')
      }
    ],
    button: false,
    alignment: 'left'
  }
];

// Steps Section of Hotel Landing
export const hotelStepsSectionData = [
  {
    id: 0,
    title: I18n.t('views.static_pages.landing.section_5.header_1.text_1'),
    image: GirlHammock,
    imageAlt: 'Girl in Hammock',
    descriptionType: 'list',
    descriptionContent: [
      {
        title: I18n.t('views.static_pages.landing.section_5.header_2.text_1'),
        description: I18n.t('views.static_pages.landing.section_5.header_2.sub_text_1')
      },
      {
        title: I18n.t('views.static_pages.landing.section_5.header_3.text_1'),
        description: I18n.t('views.static_pages.landing.section_5.header_3.sub_text_1')
      },
      {
        title: I18n.t('views.static_pages.landing.section_5.header_4.text_1'),
        description: I18n.t('views.static_pages.landing.section_5.header_4.sub_text_1')
      }
    ],
    button: false,
    alignment: 'left'
  }
];

// Stats Section of Landing
export const statsSectionData = [
  {
    number: I18n.t('views.static_pages.landing.section_7.header_1.text_1'),
    item: I18n.t('views.static_pages.landing.section_7.header_1.sub_text_1')
  },
  {
    number: I18n.t('views.static_pages.landing.section_7.header_2.text_1'),
    item: I18n.t('views.static_pages.landing.section_7.header_2.sub_text_1')
  },
  {
    number: `${numOfHotels}${I18n.t('views.static_pages.landing.section_7.header_3.text_1')}`,
    item: I18n.t('views.static_pages.landing.section_7.header_3.sub_text_1')
  },
  {
    number: `${numOfCountries}+`,
    item: I18n.t('views.static_pages.landing.section_7.header_4.sub_text_1')
  }
];

// Key Points to Share for Agent Enrollment 
export const agentEnrollmentKeyPoints = [
  'The Guestbook is the largest rewards network for independent & boutique brand hotels',
  'Guests earn 5% Cash Back/15% Cash Forward for every reservation booked direct with this hotel or any Guestbook partner hotel',
  'Cash Back is redeemable via PayPal and Gift Cards',
  'Cash Forward is redeemable for a future stay at any Guestbook partner hotel',
  'Guests that enroll during their stay are not eligible for Cash Rewards for their current stay, but are eligible for the below New Member Incentives'
];

// New Member Incentives for Agent Enrollemnt
export const agentEnrollmentMemberIncentive = [
  '$15 USD (or currency equivalent) Cash Forward Bonus - For all guests enrolled by a hotel agent (using this form)',
  '$5 USD (or currency equivalent) Cash Back Bonus - for guests. Guests that enroll DURING their stay (must submit proof of stay to The Guestbook, regardless of how they booked)'
];

// All text found in Rewards Overview Iframe
export const rewardsOverviewText = {
  introHeader: I18n.t('views.static_pages.rewards_overview_iframe.header_1'),
  introSubheader: I18n.t('views.static_pages.rewards_overview_iframe.subheader_1'),
  navWithInstay: [
    I18n.t('views.static_pages.rewards_overview_iframe.all'), 
    I18n.t('views.static_pages.rewards_overview_iframe.instay_section.title_1'), 
    I18n.t('views.static_pages.rewards_overview_iframe.cashback_section.title_1'), 
    I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.title_1'), 
    I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.title_1')
  ],
  navWithoutInstay: [
    I18n.t('views.static_pages.rewards_overview_iframe.all'),
    I18n.t('views.static_pages.rewards_overview_iframe.cashback_section.title_1'), 
    I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.title_1'), 
    I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.title_1')
  ],
  navWithOnlyCBAndDonation: [
    I18n.t('views.static_pages.rewards_overview_iframe.cashback_section.title_1'), 
    I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.title_1')
  ],
  nonInstayCards: [
    {
      title: I18n.t('views.static_pages.rewards_overview_iframe.cashback_section.title_1'),
      description: I18n.t('views.static_pages.rewards_overview_iframe.cashback_section.description'),
      buttonText: I18n.t('views.static_pages.rewards_overview_iframe.cashback_section.button'),
      backgroundImg: CashBackCard,
      backgroundImgYotel: CashBackYotelCard
    },
    {
      title: I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.title_1'),
      description: I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.description'),
      buttonText: I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.button'),
      backgroundImg: CashForACauseCard,
      backgroundImgMondrian: CashForACauseMondrianCard,
      backgroundImgYotel: CashForACauseYotelCard
    },
    {
      title: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.title_1'),
      description: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.description'),
      buttonText: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.button'),
      backgroundImg: CashForwardCard,
      backgroundImgMondrian: CashForwardMondrianCard,
      backgroundImgYotel: CashForwardYotelCard
    }
  ],
  instayCard: {
    title: I18n.t('views.static_pages.rewards_overview_iframe.instay_section.title_1'),
    description: I18n.t('views.static_pages.rewards_overview_iframe.instay_section.description'),
    buttonText: I18n.t('views.static_pages.rewards_overview_iframe.instay_section.button'),
    backgroundImg: InStayCard,
    backgroundImgYotel: InstayYotelCard
  },
  signupCard: {
    header: I18n.t('views.static_pages.rewards_overview_iframe.signup_section.title_1'),
    description: I18n.t('views.static_pages.rewards_overview_iframe.signup_section.description'),
    footerSignup: I18n.t('views.static_pages.rewards_overview_iframe.signup_section.buttons.footer_signup'),
    cardSignup: I18n.t('views.static_pages.rewards_overview_iframe.signup_section.buttons.card_signup'),
    login: I18n.t('views.static_pages.rewards_overview_iframe.signup_section.buttons.login'),
    tileImage: TilePhoneImg,
    footerImage: FooterPhoneImg
  },
  instaySection: {
    bannerImg: InstayBanner,
    bannerImgYotel: InstayYotelBanner,
    title: I18n.t('views.static_pages.rewards_overview_iframe.instay_section.title_2'),
    retailPrice: I18n.t('views.static_pages.rewards_overview_iframe.instay_section.retail_price'),
    memberPrice: I18n.t('views.static_pages.rewards_overview_iframe.instay_section.member_price')
  },
  cashbackSection: {
    bannerImg: CashBackBanner,
    bannerImgYotel: CashBackYotelBanner,
    title: I18n.t('views.static_pages.rewards_overview_iframe.cashback_section.title_2')
  },
  cashForACauseSection: {
    bannerImg: CashForACauseBanner,
    bannerImgMondrian: CashForACauseMondrianBanner,
    bannerImgYotel: CashForACauseYotelBanner,
    title: I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.title_2'),
    card1: {
      text1: I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.card_1.text_1'),
      text2: `, ${I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.card_1.text_2')}`
    },
    card2: {
      text: I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.card_2.text_1')
    },
    card3: {
      text: I18n.t('views.static_pages.rewards_overview_iframe.cash_for_a_cause_section.card_3.text_1')
    }
  },
  cashForwardSection: {
    bannerImg: CashForwardBanner,
    bannerImgMondrian: CashForwardMondrianBanner,
    bannerImgYotel: CashForwardYotelBanner,
    title: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.title_1'),
    card1: {
      text: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.card_1.text_1')
    },
    card2: {
      text: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.card_2.text_1')
    },
    card3: {
      text: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.card_3.text_1')
    },
    dislaimer: I18n.t('views.static_pages.rewards_overview_iframe.cash_forward_section.disclaimer')
  },
  learnMore: I18n.t('views.static_pages.rewards_overview_iframe.learn_more')
}

// Months
export const months = [
  {name: "January", value: "01"},
  {name: "February", value: "02"},
  {name: "March", value: "03"},
  {name: "April", value: "04"},
  {name: "May", value: "05"},
  {name: "June", value: "06"},
  {name: "July", value: "07"},
  {name: "August", value: "08"},
  {name: "September", value: "09"},
  {name: "October", value: "10"},
  {name: "November", value: "11"},
  {name: "December", value: "12"}
]

// US States 
export const usStates = [
  'Select State', 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas',
  'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
  'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 
  'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

// Canadian Provinces 
export const caProvinces = ['Select Province', 'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon Territory'];

// CCPA User Type
export const CcpaUserType = [
  {name: I18n.t('views.static_pages.ccpa_form.section_1.form_1.select_1.choice_1'), value: "Authorized Agent"},
  {name: I18n.t('views.static_pages.ccpa_form.section_1.form_1.select_1.choice_2'), value: "Customer"},
  {name: I18n.t('views.static_pages.ccpa_form.section_1.form_1.select_1.choice_3'), value: "Website Visitor"},
  {name: I18n.t('views.static_pages.ccpa_form.section_1.form_1.select_1.choice_4'), value: "Other"}
];

// CCPA RequestType
export const CcpaRequestType = [
  {name: I18n.t('views.static_pages.ccpa_form.section_1.form_1.select_2.choice_1'), value: "Right to Know Specific Pieces of Personal Information"},
  {name: I18n.t('views.static_pages.ccpa_form.section_1.form_1.select_2.choice_2'), value: "Right to Know Categories of Personal Information"},
  {name: I18n.t('views.static_pages.ccpa_form.section_1.form_1.select_2.choice_3'), value: "Right to Deletion"}
];

